<template>
<div>
    <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading>
    <div class="topbar-bg topbar-during-bg"></div>
    <div class="text-content-section">
        <p class="lead">
            Search for content across the site 
        </p>
        <div class="mb-5 mr-auto" style="width: 50%" v-on:mouseleave="showSuggestions = false">
            <div class="input-group">
                <input v-on:click="openSuggestions" v-on:keyup.enter="runSearch(searchInput)" type="search" class="form-control" v-model="searchInput">
                <div class="input-group-append">
                    <button class="btn btn-secondary" type="button" id="button-search" v-on:click="runSearch(searchInput)"><i class="fa fa-search" aria-hidden="true"></i></button>
                </div>
            </div>
            <div v-show="showSuggestions" style="background: white;  border: 1px solid #ced4da; position: absolute; width: 40% ; z-index: 10; font-size: 0.9em">
                <a href="#" class="dropdown-item" v-for="(item, index) in suggestions" :key="index" :value="item" @click="searchInput = item">
                    {{ item }}
                </a>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-6 col-sm-12">
                <div v-if="searchResults && searchResults.length > 0">
                     <div v-for="(item, index) in searchResults" :key="index">
                        <a v-bind:href="item.route.href" target="_blank"><b>{{item.route.location.path.replaceAll('/', '>')}}</b></a>
                        <small style="margin-left: 10px" v-if="item.lastUpdated "><i>Last Updated:</i> {{new Date(item.lastUpdated ).toLocaleDateString("en-AU")}}</small>
                        <div v-html="setPageContent(item.content)"></div>
                        <hr>
                    </div>
                </div>
                <div v-if="noResults">
                    <h4>No results found...</h4>
                </div>                
            </div>
        </div>   
    </div>
</div>
</template>

<style>
</style>

<script>
/* eslint-disable */
import axios from 'axios';
import Loading from 'vue-loading-overlay';
export default {
    data() {
        return {
            searchInput: '',
            searchText: '',
            isLoading: false,
            searchResults: null,
            suggestions: [],
            showSuggestions: false
        }
    },
    components: {
      Loading
    },
    computed: {
        noResults: function () {
            return this.searchResults 
                && this.searchResults.length === 0;
        }
    },
    watch: {
       '$route'(to, from) {
            this.handleSiteSearch();
        },
        searchInput: function(search) {
            const vm = this;
            axios.post('/api/searches/20', { text: search }).then(response => {
                vm.suggestions = response.data.map(o => o.Text);
            }).catch(error => { 
                vm.suggestions = [];
            });
        }
    },
    mounted: function() {
        this.handleSiteSearch();
    },
    methods: {
        setPageContent: function(content) {
            const paragraphs = content.split(/\r?\n/); 
            const header = paragraphs[0];
            paragraphs.shift();  
            const snippets = [...paragraphs.filter(o => o.toLocaleLowerCase().includes(this.searchText.toLocaleLowerCase()))];
            content = snippets.join('\r\n\r\n ... \r\n\r\n'); 
            content = content.replaceAll(this.searchText, "<mark>"+this.searchText+"</mark>");
            return marked(content);
        },
        handleSiteSearch: function() {
            this.runSearch(this.$route.params.text);
        },
        runSearch: function(search) {
            if (!search) return;

            const vm = this;
            vm.searchText = search;
            vm.searchInput = search;

            vm.loading = true;
            axios.post('/api/pagecontent/search', { text: search }).then(response => {
                vm.Loading = false;

                vm.searchResults = response.data.map(o => ({
                    content: o.Content,
                    lastUpdated: o.LastUpdated,
                    route: vm.$router.resolve({ name: o.WebTabId })
                }));
            }).catch(error => { 
                vm.Loading = false; 
            });
        },
        openSuggestions: function() {
            const vm = this;
            vm.showSuggestions = true;
            axios.post('/api/searches/20', { text: vm.searchInput }).then(response => {
                vm.suggestions = response.data.map(o => o.Text);
            }).catch(error => { 
                vm.suggestions = [];
            });
        }
    }
}
</script>